// extracted by mini-css-extract-plugin
module.exports = {"input":"NumberEditor_input","editorContainer":"NumberEditor_editorContainer","notification":"NumberEditor_notification"};